import { render } from "./AnimatedLogo.vue?vue&type=template&id=2004136d"
import script from "./AnimatedLogo.vue?vue&type=script&lang=js"
export * from "./AnimatedLogo.vue?vue&type=script&lang=js"

import "./AnimatedLogo.vue?vue&type=style&index=0&id=2004136d&lang=css"
script.render = render

export default script